import React from "react";
import {
  Stack,
  Group,
  Text,
  Avatar,
  NumberInput,
  ActionIcon,
  Button,
  Divider,
} from "@mantine/core";
import { IconPlus, IconX } from "@tabler/icons-react";

const initials = name =>
  (name || "")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0])
    .join("")
    .toUpperCase();

// Allocates an MD split across users. Each row is a user with a percentage;
// the total should add up to 100.
//   rows - array of { name, percentage }
function MdSplitSection({ rows, onAddUser, onChangePercent, onRemoveUser }) {
  const total = rows.reduce((sum, r) => sum + (Number(r.percentage) || 0), 0);

  return (
    <Stack gap="md">
      <Stack gap="sm">
        {rows.map((row, index) => (
          <Group key={index} justify="space-between" wrap="nowrap">
            <Group gap="sm" wrap="nowrap">
              <Avatar color="orange" radius="xl" size={36}>
                {initials(row.name)}
              </Avatar>
              <Text fw={500} size="sm">
                {row.name}
              </Text>
            </Group>
            <Group gap="xs" wrap="nowrap">
              <NumberInput
                placeholder="Percentage"
                value={row.percentage}
                onChange={value => onChangePercent(index, value)}
                min={0}
                max={100}
                suffix="%"
                w={160}
              />
              <ActionIcon
                color="red"
                variant="subtle"
                onClick={() => onRemoveUser(index)}
                aria-label="Remove user"
              >
                <IconX size={16} />
              </ActionIcon>
            </Group>
          </Group>
        ))}
      </Stack>

      <Button
        variant="light"
        size="xs"
        leftSection={<IconPlus size={14} />}
        onClick={onAddUser}
        style={{ alignSelf: "flex-start" }}
      >
        Add User
      </Button>

      <Divider />

      <Group justify="space-between">
        <Text fw={700}>Total</Text>
        <Text fw={700} c={total === 100 ? "teal" : "red"}>
          {total}%
        </Text>
      </Group>
    </Stack>
  );
}

export default MdSplitSection;
